import { apiCall } from "../../api/apiBase";

export type AssessmentMode = "FREE" | "FULL";

export interface Assessment {
    id?: string;
    firmId: string;
    assessmentTypeId: string;
    assessmentTypeVersionId: string;
    notes: string;
    mode: AssessmentMode;
    createdAt?: string;
    updatedAt?: string;
}

export interface AssessmentIds {
    id: string;
    firmId: string;
    assessmentTypeId: string;
}

export interface AssessmentNoteUpdate {
    notes: string;
}

export interface AssessmentModeUpdate {
    mode: AssessmentMode;
}

export function getFirmAssessments(firmId: string): Promise<Assessment[]> {
    return apiCall<Assessment[]>(`/firms/${firmId}/assessments`, "GET");
}

export function getAssessmentTypeAssessments(
    assessmentTypeId: string
): Promise<Assessment[]> {
    return apiCall<Assessment[]>(
        `/assessment-types/${assessmentTypeId}/assessments`,
        "GET"
    );
}

export function getAssessment(
    firmId: string,
    assessmentId: string
): Promise<Assessment> {
    return apiCall<Assessment>(
        `/firms/${firmId}/assessments/${assessmentId}`,
        "GET"
    );
}

export function createAssessment(
    firmId: string,
    assessment: Assessment
): Promise<Assessment> {
    return apiCall<Assessment>(
        `/firms/${firmId}/assessments`,
        "POST",
        assessment
    );
}

export function updateAssessmentNotes(
    firmId: string,
    assessmentId: string,
    update: AssessmentNoteUpdate
): Promise<Assessment> {
    return apiCall<Assessment>(
        `/firms/${firmId}/assessments/${assessmentId}/notes`,
        "PUT",
        update
    );
}

export function updateAssessmentMode(
    firmId: string,
    assessmentId: string,
    update: AssessmentModeUpdate
): Promise<Assessment> {
    return apiCall<Assessment>(
        `/firms/${firmId}/assessments/${assessmentId}/mode`,
        "PUT",
        update
    );
}

export function deleteAssessment(
    firmId: string,
    assessmentId: string
): Promise<void> {
    return apiCall(`/firms/${firmId}/assessments/${assessmentId}`, "DELETE");
}
